<div class="box">
  <div class="box-header table_header" ng-show="!isLoading">
    <h3 class="box-title">Videos</h3>
    <h3 class="box-title" id="regNo" style="visibility:hidden">{{RegNo}}</h3>
  </div>

  <div class="box-body video_block" ng-show="!isLoading">
    <!-- Tabs: Existing Videos (tab 1) and Inspection Video (tab 2) -->
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a class="nav-link" [class.active]="selectedTab === 'existing'" (click)="selectTab('existing')">Existing Videos</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [class.active]="selectedTab === 'inspection'" (click)="selectTab('inspection')">Inspection Video</a>
      </li>
    </ul>

    @if (selectedTab === 'existing') {
      <div>
        @if (VideoDetails.length>0) {
          <div>
            <div class="table-responsive-video">
              <table class="table table-bordered" style="margin:0;">
                <thead>
                  <tr>
                    <th> Created By</th>
                    <th> Video Date</th>
                  </tr>
                </thead>
                <tbody>
                  @for (Video of VideoDetails; track Video; let i = $index) {
                    <tr>
                      <td [class.highlight-cell]="selectedExistingIndex===i"><a  (click)="OpenVideo(Video, i);">{{Video.VideoSource}}&nbsp;({{Video.VideoType}})</a></td>
                      <td> {{Video.CreatedOn | date : "medium"}}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            <div class="video_container">
              <div>
                <video id="video" controls="controls" src="{{VideoUrl}}" crossorigin="anonymous"></video>
              </div>
              <img id="output" width="10" />
              <div class="capture_btn">
                <button id="capture" class="btn" [ngClass]="{ 'btn-primary': !captureDisabled, 'btn-disabled-grey': captureDisabled }" [disabled]="captureDisabled">Capture</button>
                <select id="quality">
                  Pdf Quality
                  <option value="0.3">1</option>
                  <option value="0.35">2</option>
                  <option value="0.4" selected>3</option>
                  <option value="0.45">4</option>
                  <option value="0.5">5</option>
                </select>
                <input type="button" class="btn" style="margin: 10px;" id="screen" [ngClass]="{ 'btn-primary': !screenshotDisabled, 'btn-disabled-grey': screenshotDisabled }" value="Enable Screenshot" name="Enable Screenshot" [disabled]="screenshotDisabled" (click)="takeScreen()" />
                <input type="button" class="btn btn-primary" value="GeneratePdf" name="GeneratePdf" (click)="GeneratePdf()" />
                @if (VideoDetails.length > 1) {
                  <input type="button" class="btn" style="margin-left:8px" [ngClass]="{ 'btn-primary': canGenerateCombinedExisting, 'btn-disabled-grey': !canGenerateCombinedExisting }" [disabled]="!canGenerateCombinedExisting" value="Generate All Screenshots PDF" (click)="GenerateCombinedPdf()" />
                }
              </div>
              <div class="thumb_block" id="screenshot">
              </div>
            </div>
          </div>
        }
      </div>
    }

    @if (selectedTab === 'inspection') {
      <div>
        <!-- Inspection video tab content. This intentionally shows the inspection-related UI separate from existing videos. -->
        @if (InspectionVideoDetails?.length>0) {
          <div>
            <div class="table-responsive-video">
              <table class="table table-bordered" style="margin:0;">
                <thead>
                  <tr>
                    <th>Inspection Id</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  @for (insp of InspectionVideoDetails; track insp; let i = $index) {
                    <tr>
                      <td [class.highlight-cell]="selectedInspectionIndex===i"><a (click)="OpenInspectionVideo(insp, i)">{{insp.InspectionId}}</a></td>
                      <td>{{insp.StatusName}}</td>
                      <td><button class="btn btn-primary" (click)="OpenInspectionVideo(insp, i)">Open</button></td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            <div class="video_container">
              <video id="inspectionVideo" controls="controls" [src]="InspectionVideoUrl" crossorigin="anonymous"></video>
              <img id="output" width="10" />
              <div class="capture_btn">
                <button id="capturenstp" class="btn" [ngClass]="{ 'btn-primary': !captureDisablednstp, 'btn-disabled-grey': captureDisablednstp }" [disabled]="captureDisablednstp">Capture</button>
                <select id="quality">
                  Pdf Quality
                  <option value="0.3">1</option>
                  <option value="0.35">2</option>
                  <option value="0.4" selected>3</option>
                  <option value="0.45">4</option>
                  <option value="0.5">5</option>
                </select>
                <input type="button" class="btn" style="margin: 10px;" id="screen" [ngClass]="{ 'btn-primary': !screenshotDisablednstp, 'btn-disabled-grey': screenshotDisablednstp }" value="Enable Screenshot" name="Enable Screenshot" [disabled]="screenshotDisablednstp" (click)="takeScreennstp()" />
                <input type="button" class="btn btn-primary" value="GeneratePdf" name="GeneratePdf" (click)="GeneratePdfnstp()" />
                @if (InspectionVideoDetails?.length > 1) {
                  <input type="button" class="btn" style="margin-left:8px" [ngClass]="{ 'btn-primary': canGenerateCombinedInspection, 'btn-disabled-grey': !canGenerateCombinedInspection }" [disabled]="!canGenerateCombinedInspection" value="Generate All Screenshots PDF" (click)="GenerateCombinedPdfInspection()" />
                }
              </div>
              <div class="thumb_block" id="screenshotnstp">
              </div>
            </div>
          </div>
        } @else {
          <ng-template [ngTemplateOutlet]="noInspection"></ng-template>
        }
      </div>
    }
    @if (VideoDetails.length==0) {
      <div style="text-align: center;">
        <span>No Video Found</span>
      </div>
    }
  </div>
</div>
